import React from 'react';
import { Button, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
const useStyles = makeStyles((theme) => ({
	warning: {
		background: theme.palette.warning.main,
		'&:hover': {
			background: theme.palette.warning.dark,
		},
		color: 'black',
	},
	error: {
		background: theme.palette.error.main,
		'&:hover': {
			background: theme.palette.error.dark,
		},
		color: 'white',
	},
	success: {
		background: theme.palette.success.main,
		'&:hover': {
			background: theme.palette.success.dark,
		},
		color: 'white',
	},
	backButton: {
		background: 'transparent',
		color: theme.palette.secondary.main,
		fontSize: '3rem',
		minWidth: 0,
		padding: 0,
		'&:hover': {
			color: theme.palette.secondary.dark,
			background: 'transparent',
		},
	},
	button: {
		margin: theme.spacing(1),
	},
}));

export const ErrorButton = (props) => {
	const classes = useStyles();
	return <Button className={classes.error} {...props} />;
};

export const WarningButton = (props) => {
	const classes = useStyles();
	return <Button className={classes.warning} {...props} />;
};

export const SuccessButton = (props) => {
	const classes = useStyles();
	return <Button className={classes.success} {...props} />;
};

export const BackButton = () => {
	const history = useHistory();
	const classes = useStyles();
	return (
		<Tooltip title="Back">
			<Button
				variant="contained"
				color="primary"
				className={classes.button}
				startIcon={<ArrowLeftIcon />}
				onClick={() => history.goBack()}
      		>
        		Back
      		</Button>
			
		</Tooltip>
	);
};
